import React from "react";
import { Navbar, Dropdown } from "react-bootstrap";
import { BsListNested } from "react-icons/bs";
import { CiBellOn } from "react-icons/ci";
import { IoMoonOutline, IoLogOutOutline } from "react-icons/io5";
import { PiUserCircle } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../store/slices/auth";

export default function HeaderNav({ mobileMenuclick }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // unwrap() throws automatically if logout fails
      await dispatch(logout()).unwrap();

      // Redirect only after successful logout
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <Navbar bg="white" className="top-header shadow-sm px-4">
      <div className="header-inner d-flex align-items-center w-100">
        {/* Left: Hamburger */}
        <button className="hamburger-btn" onClick={mobileMenuclick}>
          <BsListNested />
        </button>

        {/* Center: Welcome */}
        <div className="welcome-text ms-3">
          <span>WELCOME!</span>
        </div>

        {/* Right: Actions */}
        <div className="header-actions d-flex align-items-center ms-auto">
          {/* Theme */}
          <button className="icon-btn">
            <IoMoonOutline style={{ fontSize: "20px" }} />
          </button>

          {/* Notifications */}
          <button className="icon-btn notification-btn">
            <CiBellOn style={{ fontSize: "24px" }} />
          </button>

          {/* Profile */}
          <Dropdown align="end">
            <Dropdown.Toggle
              as="div"
              className="icon-btn dropdown-toggle-custom"
            >
              <PiUserCircle style={{ fontSize: "22px" }} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>Profile Settings</Dropdown.Item>
              <Dropdown.Item>Preferences</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item className="text-danger" onClick={handleLogout}>
                <IoLogOutOutline style={{ marginRight: "6px" }} />
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </Navbar>
  );
}
